const state = {
  system: {
    overview: {},
    recentTraffic: {},
    topCategories: { allowed: [], blocked: [] },
    topDomains: { allowed: [], blocked: [] },
    topUsers: {},
    trafficHistory: {},
  },
  msp: {
    overview: {},
  },
  customer: {
    overview: {},
    recentTraffic: {},
    topCategories: { allowed: [], blocked: [] },
    topDomains: { allowed: [], blocked: [] },
    topUsers: {},
    trafficHistory: {},
  },
  location: {
    overview: {},
    topCategories: { allowed: [], blocked: [] },
    topDomains: { allowed: [], blocked: [] },
  },
  dashboard: {
    "categories-allow": { response: { data: [] } },
    "categories-block": { response: { data: [] } },
    "domains-allow": { response: { data: [] } },
    "domains-block": { response: { data: [] } },
    "users-allow": { response: { data: [] } },
    "users-block": { response: { data: [] } },
    history: { response: { data: [] } },
    overview: {
      response: {
        requests: "",
        unique_domains: "",
        allowed: "",
        blocked: "",
      },
    },
    traffic: { response: { data: [] } },
  },
};

const getters = {
  systemStats: (state) => state.system,
  mspStats: (state) => state.msp,
  customerStats: (state) => state.customer,
  locationStats: (state) => state.location,
  dashboard: (state) => state.dashboard,
};

const actions = {
  // System
  async fetchSystemOverview({ commit }, { date }) {
    const response = await this._vm.$http.get(`/restapi/stats/${date || ""}`);
    return commit("setSystemOverview", response.data);
  },

  // Msps
  async fetchMspOverview({ commit }, { date, mspId }) {
    const response = await this._vm.$http.get(
      `/restapi/msp/${mspId}/stats/${date || ""}`
    );
    return commit("setMspOverview", response.data);
  },

  async fetchSystemRecentTraffic({ commit }, { day }) {
    const response = await this._vm.$http.get(`/restapi/stats/traffic/${day}`);
    return commit("setSystemRecentTrafic", response.data);
  },

  async fetchSystemTopCategories({ commit }, { type, date }) {
    const response = await this._vm.$http.get(
      `/restapi/stats/categories/${type}/${date || ""}`
    );
    return commit("setSystemTopCategories", response.data);
  },

  async fetchSystemTopDomains({ commit }, { type, date }) {
    const response = await this._vm.$http.get(
      `/restapi/stats/domains/${type}/${date || ""}`
    );
    return commit("setSystemTopDomains", response.data);
  },

  async fetchSystemTopUsers({ commit }, { type, date }) {
    const response = await this._vm.$http.get(
      `/restapi/stats/users/${type}/${date || ""}`
    );
    return commit("setSystemTopUsers", response.data);
  },

  async fetchSystemTrafficHistory({ commit }, { days }) {
    const response = await this._vm.$http.get(`/restapi/stats/history/${days}`);
    return commit("setSystemTrafficHistory", response.data);
  },

  // Customer
  async fetchCustomerOverview({ commit }, { id, date }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/stats/${date || ""}`
    );
    return commit("setCustomerOverview", response.data);
  },

  async fetchCustomerRecentTraffic({ commit }, { id, day }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/stats/traffic/${day}`
    );
    return commit("setCustomerRecentTrafic", response.data);
  },

  async fetchCustomerTopCategories({ commit }, { id, type, date }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/stats/categories/${type}/${date || ""}`
    );
    return commit("setCustomerTopCategories", {
      type: type,
      data: response.data,
    });
  },

  async fetchCustomerTopDomains({ commit }, { id, type, date }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/stats/domains/${type}/${date || ""}`
    );
    return commit("setCustomerTopDomains", {
      type: type,
      data: response.data,
    });
  },

  async fetchCustomerTopUsers({ commit }, { id, type, date }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/stats/users/${type}/${date || ""}`
    );
    return commit("setCustomerTopUsers", {
      type: type,
      data: response.data,
    });
  },

  async fetchCustomerTrafficHistory({ commit }, { id, days }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/stats/history/${days}`
    );
    return commit("setCustomerTrafficHistory", response.data);
  },

  // Locations
  async fetchLocationOverview({ commit }, { id, locationId, date }) {
    const response = await this._vm.$http.get(
      date
        ? `/restapi/users/${id}/locations/${locationId}/stats?start=${date.start}&end=${date.end}`
        : `/restapi/users/${id}/locations/${locationId}/stats`
    );
    return commit("setLocationOverview", response.data);
  },

  async fetchLocationTopCategories(
    { commit },
    { id, locationId, action, date }
  ) {
    const response = await this._vm.$http.get(
      date
        ? `/restapi/users/${id}/locations/${locationId}/stats/categories/${action}?start=${date.start}&end=${date.end}`
        : `/restapi/users/${id}/locations/${locationId}/stats/categories/${action}`
    );
    return commit("setLocationTopCategories", {
      action,
      data: response.data.data,
    });
  },

  async fetchLocationTopDomains({ commit }, { id, locationId, action, date }) {
    const response = await this._vm.$http.get(
      date
        ? `/restapi/users/${id}/locations/${locationId}/stats/domains/${action}?start=${date.start}&end=${date.end}`
        : `/restapi/users/${id}/locations/${locationId}/stats/domains/${action}`
    );
    return commit("setLocationTopDomains", {
      action,
      data: response.data.data,
    });
  },

  // Dashboard
  async fetchUserDashboard({ commit }, { id, date, day, days }) {
    const response = await this._vm.$http.post(`/restapi/batch`, {
      overview: {
        method: `GET`,
        path: `/users/${id}/stats/${date}`,
      },
      traffic: {
        method: `GET`,
        path: `/users/${id}/stats/traffic/${day || "today"}`,
      },
      "categories-allow": {
        method: `GET`,
        path: `/users/${id}/stats/categories/allowed/${date || ""}`,
      },
      "categories-block": {
        method: `GET`,
        path: `/users/${id}/stats/categories/blocked/${date || ""}`,
      },
      "domains-allow": {
        method: `GET`,
        path: `/users/${id}/stats/domains/allowed/${date || ""}`,
      },
      "domains-block": {
        method: `GET`,
        path: `/users/${id}/stats/domains/blocked/${date || ""}`,
      },
      "users-allow": {
        method: `GET`,
        path: `/users/${id}/stats/users/allowed/${date || ""}`,
      },
      "users-block": {
        method: `GET`,
        path: `/users/${id}/stats/users/blocked/${date || ""}`,
      },
      history: {
        method: `GET`,
        path: `/users/${id}/stats/history/${days || "5"}`,
      },
    });
    commit("setUserDashboard", response);
  },
};

const mutations = {
  setSystemOverview: (state, data) => (state.system.overview = data),
  setMspOverview: (state, data) => (state.msp.overview = data),
  setSystemRecentTrafic: (state, data) => (state.system.recentTraffic = data),
  setSystemTopCategories: (state, data) => (state.system.topCategories = data),
  setSystemTopDomains: (state, data) => (state.system.topDomains = data),
  setSystemTopUsers: (state, data) => (state.system.topUsers = data),
  setSystemTrafficHistory: (state, data) =>
    (state.system.trafficHistory = data),
  setCustomerOverview: (state, data) => (state.customer.overview = data),
  setCustomerRecentTrafic: (state, data) =>
    (state.customer.recentTraffic = data),
  setCustomerTopCategories: (state, data) =>
    (state.customer.topCategories[`${data.type}`] = data.data),
  setCustomerTopDomains: (state, data) =>
    (state.customer.topDomains[`${data.type}`] = data.data),
  setCustomerTopUsers: (state, data) =>
    (state.customer.topUsers[`${data.type}`] = data.data),
  setCustomerTrafficHistory: (state, data) =>
    (state.customer.trafficHistory = data),
  setLocationOverview: (state, data) => (state.location.overview = data),
  setLocationTopCategories: (state, data) =>
    (state.location.topCategories[`${data.action}`] = data.data),
  setLocationTopDomains: (state, data) =>
    (state.location.topDomains[`${data.action}`] = data.data),
  setUserDashboard: (state, data) => (state.dashboard = data.data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
